export default "__VITE_ASSET__iITz6PZX__"